import { FC } from "react";
import { TagListContainer } from "./tag-list.style";

// A list of tags displayed in a flex
export const TagList: FC<{
  tags: string;
  className?: string;
  fg?: string;
  bg?: string;
}> = ({ tags, className, fg, bg }) => {
  const tagsArray = tags?.split(",");
  return (
    <TagListContainer className={className} {...{ fg, bg }}>
      {tags?.length > 0 &&
        tagsArray?.map(
          (tag) =>
            tag && (
              <li key={tag} className="tag-list__item">
                {tag}
              </li>
            )
        )}
    </TagListContainer>
  );
};
